import {ICarouselProps, ECarouselDirection} from 'brandComponents/Carousel';

export const defaultCarouselConfig: ICarouselProps['config'] = {
	autoplay: false,
	loop: true,
	direction: ECarouselDirection.HORIZONTAL,
	slidesPerView: 'auto',
	spaceBetween: 10,
	navigationConfig: {
		enabled: true,
	},
	grabCursor: true,
	breakpoints: {},
};
